export default [
    {
        title: 'ادمین',
        icon: 'UserIcon',
        children: [
            {
                title: 'لیست کاربران',
                route: 'user-all',
                icon: 'ListIcon',
            },
            {
                title: 'لیست شرکت ها',
                route: 'company-all',
                icon: 'ListIcon',
            },
            {
                title: 'لیست تردد ها',
                route: 'record-all',
                icon: 'ListIcon',
            },
        ],
    },
]
